export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
// You need generate and set your own API key
// from forkify-api.herokuapp.com/v2
export const KEY = "5aec1b77-234d-4990-9a5e-66a596915ef0";
export const MODAL_CLOSE_SEC = 2.5;
